import React from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import classes from './ecosytemOpportunity.module.scss';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';

const EcoOppBenchmarkTable = ({
  isMandatoryFiltersSelected,
  benchmarkData,
  isPayerView,
}) => {
  const allBenchmarkItems = [
    {
      label: `Average Estimated Contribution to National ${isPayerView ? '' : 'Parent '}Payer Sales (all BoB) Across ${isPayerView ? '' : 'Parent '}Payers`,
      value: benchmarkData?.benchmark?.ecoToNatPayerSales,
      tooltip: 'Test - Actual tooltip to be incorporated soon', // Will be updated with actual tooltip content
    },
    {
      label: `Average Estimated ${isPayerView ? '' : 'Parent '}Payer Contribution to Ecosystem (all BoB) Across Ecosystems`,
      value: benchmarkData?.benchmark?.payerToEcoSales,
      tooltip: 'Test - Actual tooltip to be incorporated soon', // Will be updated with actual tooltip content
    },
    {
      label: `National ${isPayerView ? '' : 'Parent '}Payer-Specific Product Market Share`,
      value: benchmarkData?.marketSharePercent?.livesNormNationPayer,
      tooltip: `[Lives-normalized] National-level market share for the selected product relative to the market basket, and for the selected ${isPayerView ? '' : 'Parent '}Payer (R3M)`,
    },
    {
      label: `National Product Market Share (${isPayerView ? '' : 'Parent '}Payer-Agnostic)`,
      value: benchmarkData?.marketSharePercent?.national,
      tooltip:
        'National-level market share for the selected product relative to the market basket, included as a benchmark (R3M)',
    },
  ];

  const benchMarkTooltip = (
    <Tooltip className='gne-tooltip'>
      Test - Actual tooltip to be incorporated soon
    </Tooltip>
  );

  return (
    <div className={`${classes.opportunityContainer} p-4`}>
      <div className='text text__bold pb-4 title__large'>
        Benchmarks
        <OverlayTrigger overlay={benchMarkTooltip}>
          <i className='icon icon__info__gray ms-2'></i>
        </OverlayTrigger>
      </div>
      <Row className='d-flex flex-wrap gap-3'>
        {allBenchmarkItems.map((item, index) => {
          return (
            <Col
              key={index}
              // className={classes.benchmarkTableCol}
            >
              <BenchMarkItem
                item={item}
                isMandatoryFiltersSelected={isMandatoryFiltersSelected}
                index={index}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default EcoOppBenchmarkTable;

const BenchMarkItem = ({ item, isMandatoryFiltersSelected, index }) => {
  const benchMarkValue =
    ((index === 2 || index === 3) && !isMandatoryFiltersSelected) ||
    !item?.value
      ? ''
      : `${Number(item.value).toFixed(2)}%`;

  return (
    <>
      <span className='text__x-small align-items-center d-flex mb-3'>
        <span className='text__normal text__blue text__bold me-2'>
          {benchMarkValue || '-'}
        </span>
        <OverlayTrigger
          overlay={<Tooltip className='gne-tooltip'>{item?.tooltip}</Tooltip>}>
          <i className='icon icon__info__gray ms-1'></i>
        </OverlayTrigger>
      </span>
      <span>{item?.label}</span>
    </>
  );
};
